import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import tools from '../tools';
import styles from '../styles.module.css';
import classNames from 'classnames';
import WithHint from './WithHint';
import WhiteboardController from '../controllers/WhiteboardController';
import StylusToolButton from './StylusToolButton';
import ToolSearch from '../tools/ToolSearch';
import { useTippyTarget } from '../components/tippyContext';

interface ActionsToolbarProps {
  commentsEnabled: boolean;
}

const ActionsToolbar: React.FC<ActionsToolbarProps> = ({ commentsEnabled }) => {
  const controller = useController(WhiteboardController);
  const { hasActiveObjectTransformation } = controller.state;
  const tool = tools.ToolStylusComment;
  const stylus = controller.stylusComment;

  const SearchButtonComponent = ToolSearch.buttonComponent();
  const tippyTarget = useTippyTarget();

  return (
    <div
      className={classNames(styles.commentsToolbar, styles.toolbarCommon, {
        [styles.toolbarFade]: hasActiveObjectTransformation,
      })}
    >
      {commentsEnabled && (
        <WithHint key={tool.toolName} tool={tool} singleton={tippyTarget}>
          <StylusToolButton stylus={stylus} />
        </WithHint>
      )}

      <SearchButtonComponent />
    </div>
  );
};

export default ApplicationView(ActionsToolbar);
